// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './assets/css/main.scss' // 公共样式
import 'lib-flexible'
import store from './store'
import moment from 'moment'
import '@/permission' // permission control
import VueClipboard from 'vue-clipboard2'

// import Vconsole from 'vconsole'

import Vant, { Lazyload } from 'vant'
import 'vant/lib/index.css'

// let vConsole = new Vconsole()
// export default vConsole
Vue.use(Vant)
Vue.use(Lazyload)
Vue.use(VueClipboard)

Vue.config.productionTip = false

Vue.filter('dateformat', function (dataStr, pattern = 'YYYY-MM-DD HH:mm:ss') {
  return moment(dataStr).format(pattern)
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js